import React from 'react';

import { LENDER_ZIP } from '../../constants';
import LenderAddressTextField from './LenderAddressTextField.interstate';

const LenderZipField = () => (
    <LenderAddressTextField id="LenderZipField" dataTestId="lender-zip" label={LENDER_ZIP} name="lender-zip" field="postalCode" />
);

export default LenderZipField;
